<template>
    <component :is="component" :data="data" v-if="component" />
</template>
<script>
export default {
    name: 'dynamic-link',
    props: ['data', 'type'],
    data() {
        return {
            component: null,
        }
    },
    computed: {
        loader() {
            if (!this.type) {
                return null
            }
            return () => import(`./${this.type}`)
        },
    },
    mounted() {
        this.renderComponent();
    },
    methods: {
        renderComponent() {
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('./main-menu/main-menu.vue')
                })
        }
    },
    watch: {
        type: function(newval, oldval) {
            if (newval != oldval) {
                this.renderComponent();
            }
        }
    }
}
</script>
